import {Component} from "../interface/component";
import {inject, injectable} from "inversify";
import SERVICE_IDENTIFIER from "../container/identifiers";
import {ModalService} from "../service/modal";

@injectable()
export class ButtonLockedComponent implements Component {

    private $root:JQuery;
    @inject(SERVICE_IDENTIFIER.MODAL) public modalService: ModalService;

    init(elem:HTMLElement) {
        this.$root = $(elem);
        this.bindUI();
    }

    /**
     * Sets up fancy box for this gallery. Sets up filter functionality.
     */
    private bindUI() {
        this.$root.on({ click: this.showModal });
    }

    private showModal = (ev:MouseEvent) => {
        ev.preventDefault();
        let $target = $(ev.currentTarget);
        let heading = $target.data('heading') ? $target.data('heading') : 'You cannot do this.';
        let message = $target.data('message') ? $target.data('message') : 'Sorry, but this action is forbidden. If you are not logged in please try logging in. Otherwise please get in touch with us at <a href="help@curatorspace.com">help@curatorspace.com</a>.';
        this.modalService.showConfirm(heading, '<p>'+message+'</p>', [
            {
                label: 'Okay',
                class: 'btn-primary',
                events: {
                    click: () => this.modalService.hideConfirm()
                }
            }
        ]);
    }
}